<div class="page" [class.loading]="status === UiStatus.Idle" (click)="pageClicked()" (tap)="pageClicked()">
  <div #pageContent class="content">

    <canvas #captureCanvas class="capture-canvas" hidden></canvas>

    <app-media-recorder #recorder mimeType="video/webm"></app-media-recorder>

    <app-overlay #overlay class="overlay"></app-overlay>

    <div #guides class="guides">
      @if (status === UiStatus.Idle) {
        <div class="place-face white" trans="face_check.check.loading"></div>
      }

      @else if (!stream) {
        <div class="place-face white" trans="face_check.check.needs_video"></div>
      }

      @else if (status === UiStatus.NeedsStart) {
        @if (IS_DESKTOP) {
          <div class="place-face white" trans="face_check.check.desktop.tap_to_start"></div>
        } @else {
          <div class="place-face white tapToStart" trans="face_check.check.tap_to_start"></div>
        }
      }

      @else if (status === UiStatus.Started) {
        <div class="place-face">
          @switch (overlay.status) {
            @case (OverlayStatus.Initial) {
              <div class="white" trans="face_check.check.instructions.align"></div>
            }
            @case (OverlayStatus.TimedOut) {
              <app-icon-message transMessage="face_check.check.instructions.timed_out"></app-icon-message>
            }
            @case (OverlayStatus.FaceDetected) {
              <div class="success" trans="face_check.check.instructions.detected"></div>
            }
            @case (OverlayStatus.Complete) {
              <div class="icon-guide">
                <mat-icon class="inset-icon color-success">check_circle</mat-icon>
                <p class="success" trans="face_check.check.instructions.complete"></p>
              </div>
            }
          }
        </div>
      }
    </div>

    <div #centerPaddingArea class="center-padding-area"></div>

    <div #buttonArea class="button-area">
      @if (status === UiStatus.NeedsStart && IS_DESKTOP) {
        <div class="image-positioner">
          <div (click)="handleChangeMedia()" class="image-container">
            <mat-icon class="icon">switch_camera</mat-icon>
            <p trans="face_check.check.button.camera"></p>
          </div>
        </div>
        <div class="record-button-area">
          <app-face-record-button
            class="record-button"
            (started)="startTracking()"
            [isCountDownEnabled]="false">
          </app-face-record-button>
          <span trans="face_check.check.tap_start"></span>
        </div>
      }
      @if (status === UiStatus.Started && overlay.status !== OverlayStatus.FaceDetected && overlay.status !== OverlayStatus.Complete) {
        <div class="image-positioner">
          <div class="image-container" routerLink="/help/face">
            <mat-icon class="icon">help</mat-icon>
            <p trans="face_check.check.button.help"></p>
          </div>
        </div>
      }
      @if (overlay.status === OverlayStatus.TimedOut) {
        <div class="image-positioner" (click)="startTracking()">
          <div class="image-container">
            <mat-icon class="icon">replay</mat-icon>
            <p trans="face_check.check.button.retry"></p>
          </div>
        </div>
      }
    </div>
  </div>
</div>
